export default __webpack_public_path__ + "static/media/MapaUSActualizado02.930d187b.png";